export const FETCH_PRODUCT_TYPE_MEMBERS_STARTED = 'FETCH_PRODUCT_TYPE_MEMBERS_STARTED' as const;
export const FETCH_PRODUCT_TYPE_MEMBERS_FULFILLED = 'FETCH_PRODUCT_TYPE_MEMBERS_FULFILLED' as const;
export const UPDATE_PRODUCT_TYPE_MEMBER_ROLE_STARTED = 'UPDATE_PRODUCT_TYPE_MEMBER_ROLE_STARTED' as const;
export const UPDATE_PRODUCT_TYPE_MEMBER_ROLE_FULFILLED =
  'UPDATE_PRODUCT_TYPE_MEMBER_ROLE_FULFILLED' as const;

export const fetchProductTypeMembers = (productTypeId?: unknown) => ({
  type: FETCH_PRODUCT_TYPE_MEMBERS_STARTED,
  payload: productTypeId,
});

export const fetchProductTypeMembersFulfilled = (data: unknown) => ({
  type: FETCH_PRODUCT_TYPE_MEMBERS_FULFILLED,
  payload: data,
});

export const updateProductTypeMemberRole = (data: unknown) => ({
  type: UPDATE_PRODUCT_TYPE_MEMBER_ROLE_STARTED,
  payload: data,
});

export const updateProductTypeMemberRoleFulfilled = (data: unknown) => ({
  type: UPDATE_PRODUCT_TYPE_MEMBER_ROLE_FULFILLED,
  payload: data,
});
